import React from "react";
import moment from "moment";

export const SingleSoci = ({element, file}) => {
  return (
    <div className="file-container">
      <div className="conture"></div>
      <div className="container-items">
        <span className="gc-icon-functional-doc-pdf-1-col"></span>
        <div className="description">
          <p className="text-md-20 font-semi-bold text-style">
            {element.label}
          </p>
          <p className="text-sm font-light">
            {file
              ? file +
              " " +
              moment(element.date).format("DD MMMM YYYY").toUpperCase()
              : element.title +
              " " +
              moment(element.date).format("DD MMMM YYYY").toUpperCase()}
          </p>
        </div>
        <div className="info-data">
          <p className="text-md font-regular size-text">
            {element.size + " mb".toUpperCase()}
          </p>
          <p className="text-md font-regular space-text">
            {"|".toUpperCase()}
          </p>
          <button className="button-download">
            <span className="gc-icon-functional-download-1-col"></span>
          </button>
        </div>
      </div>
    </div>
  );
}

export const SociFile = (data, t, file) => {
  return (
    <>
      {data.map((element) => {
        return <SingleSoci element={element} file={file}/>
      })}
    </>
  );
};
